import { Context } from "@nuxt/types";
import posthog, { PostHog } from "posthog-js";
import Vue from "vue";

declare module "vue/types/vue" {
    interface Vue {
        $posthog: PostHog;
    }
}

/**
 * Initialize posthog and inject it globally
 *
 * @param ctx Vue context
 * @param inject Inject function
 */
export default function (ctx: Context, inject: any) {
    // Init PostHog
    posthog.init("phc_SETwSzIiwu6kTS8C3JKWBCMjuYZWIK5r7U3QE2Cqyis", {
        api_host: "https://hog.knights-of-cathena.com",
        capture_pageview: false,
        persistence: "localStorage",
    });

    // Inject PostHog into the application and make it available via this.$posthog (or app.$posthog)
    inject("posthog", posthog);

    // Make sure that pageviews are captured with each route change
    ctx.app.router?.afterEach(to => {
        Vue.nextTick(() => {
            /* Note: this might also be a good place to call posthog.register(...) in order to update your properties
      on each page view
      */
            posthog.capture("$pageview", {
                $current_url: to.fullPath,
            });
        });
    });
}
